/* eslint-disable prettier/prettier */
import React from "react";
import { TextField } from "@mui/material";
import { Filter, InputChange } from "./datafilter-types";

interface RegexFilterProps {
    filter: Filter;
    onChangeString: (name: string, ev: InputChange) => void;
}

const RegexFilter: (props: RegexFilterProps) => JSX.Element = ({
    filter,
    onChangeString,
}) => {
    const { name, placeholder, value } = filter;
    const onInputChange = (name: string, ev: InputChange) => {
        const { value } = ev.target;
        if (value === "") {
            onChangeString(name, ev);
            return;
        }
        // Check if input is valid regex format
        if (filter?.regex && filter.regex.test(value)) {
            onChangeString(name, ev);
        }
    };
    return (
        <TextField
            aria-label={placeholder}
            inputProps={{
                "data-testid": `${name}-input`,
            }}
            onChange={(ev) => {
                onInputChange(name, ev);
            }}
            label={placeholder}
            value={value}
        />
    );
};

export default RegexFilter;
